import Button from "app/storybookComponents/Button";
import WeeklyCheckInWelcomeIllustration from "resources/images/WeeklyCheckInWelcomeIllustration.png";
import { useMemo, useState } from "react";
import { Card } from "react-bootstrap";
import WeeklyCheckInWelcomeModal from "./WeeklyCheckInWelcomeModal";
import { WeeklyCheckInMerchandisingType } from "./types";
import { getWeeklyCheckInMerchandisingContent } from "./helpers";
import { WEEKLY_CHECK_IN_FEATURE_NAME } from "app/containers/WeeklyCheckInMonitor/constants";
import { useNavigate } from "react-router-dom";

interface Props {
  type: WeeklyCheckInMerchandisingType;
  isNew?: boolean;
}

const WeeklyCheckInWelcomeCard = ({ type, isNew = true }: Readonly<Props>) => {
  const navigate = useNavigate();
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState<{
    isOpen: boolean;
  }>({
    isOpen: false,
  });

  const WEEKLY_CHECK_IN_MERCHANDISING_CONTENT = useMemo(
    () => getWeeklyCheckInMerchandisingContent(type),
    [type]
  );

  return (
    <>
      <WeeklyCheckInWelcomeModal
        show={isPreviewModalOpen.isOpen}
        onHide={() => setIsPreviewModalOpen({ isOpen: false })}
        type={type}
      />
      <Card className="weekly-check-in-welcome-container">
        <div className="weekly-check-in-welcome-container__content">
          <div className="row-gap-8px align-items-center">
            <h3>{WEEKLY_CHECK_IN_FEATURE_NAME}</h3>
            {isNew && <span className="new-tag">Beta</span>}
          </div>
          <h1>{WEEKLY_CHECK_IN_MERCHANDISING_CONTENT.banner.title}</h1>
          <div className="row-gap-4px">
            <p>{WEEKLY_CHECK_IN_MERCHANDISING_CONTENT.banner.description}</p>
          </div>
          <div className="weekly-check-in-welcome-container__action-buttons">
            <div className="row-gap-8px">
              <Button
                variant="secondary-blue"
                className="white-button"
                onClick={() =>
                  setIsPreviewModalOpen({
                    isOpen: true,
                  })
                }
              >
                {WEEKLY_CHECK_IN_MERCHANDISING_CONTENT.banner.ctaText}
              </Button>
              {type === "admin" ? (
                <Button
                  variant="primary"
                  onClick={() => {
                    navigate("/AdminConsole/Organization%20Settings/Check-Ins");
                  }}
                >
                  Start Pilot
                </Button>
              ) : null}
            </div>
          </div>
        </div>
        <div className="weekly-check-in-welcome-container__illustration">
          <img
            src={WeeklyCheckInWelcomeIllustration}
            alt={WEEKLY_CHECK_IN_FEATURE_NAME}
            className="weekly-check-in-welcome-container__illustration__img"
          />
        </div>
      </Card>
    </>
  );
};

export default WeeklyCheckInWelcomeCard;
